import { render } from "./PlanPrice.vue?vue&type=template&id=3ff4d53d&scoped=true&ts=true"
import script from "./PlanPrice.vue?vue&type=script&lang=ts"
export * from "./PlanPrice.vue?vue&type=script&lang=ts"

import "./PlanPrice.vue?vue&type=style&index=0&id=3ff4d53d&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff4d53d"]])

export default __exports__